import { createSelector } from '@reduxjs/toolkit';

import { OrgStatus } from 'constants/enums';

import { selectGroups, getCurrentGroup } from './basic';

const getAuthorizedOrgs = createSelector([selectGroups], (groups) => {
  return groups.filter((g) => g.parentGid === g.gid && g.gid !== 'all');
});

const getAuthorizedSubgroups = createSelector([selectGroups], (groups) => {
  return groups.filter((g) => g.parentGid !== g.gid && g.gid !== 'all');
});

const getOrgStatus = createSelector([selectGroups, getCurrentGroup], (groups, currentGroup) => {
  if (groups.length > 0) {
    if (currentGroup?.orgStatus && currentGroup.orgStatus !== OrgStatus.ACTIVE)
      return currentGroup?.orgStatus || '';
    else if (
      currentGroup?.gid === 'all' &&
      groups[1]?.orgStatus &&
      groups[1].orgStatus !== OrgStatus.ACTIVE
    ) {
      const orgGid = (groups[1] && groups[1].parentGid) || '';
      const allSameOrg = groups
        .filter((group) => group.gid !== 'all')
        .every((group) => group.parentGid === orgGid);
      if (allSameOrg) return groups[1].orgStatus || '';
    }
  }
});

/**
 * Whether any of this account's organisations may not be served at all.
 *
 * Suspended, or held pending an NPI check [F-02] — the 7000 refuses a login for both
 * (`OrganizationStatus::blocksAccess`), and health-api strips the roles for both, so a session
 * that outlives the change has nothing left it can do. Named for what it gates rather than for
 * one of the two statuses: as `getSuspendedOrg` it silently excluded the held state and left such
 * a session sitting on a dashboard where every request 401s.
 */
const getAccessBlockedOrg = createSelector([selectGroups], (groups) =>
  groups.some(
    (g) => g.orgStatus === OrgStatus.SUSPENDED || g.orgStatus === OrgStatus.VERIFICATION_PENDING
  )
);

export { getAuthorizedOrgs, getAuthorizedSubgroups, getOrgStatus, getAccessBlockedOrg };
